import { useLocation } from 'react-router-dom';

import { Loader } from 'components/Loader';
import { Page, PagePanel } from 'components/Page';
import { useEffectOnce } from 'hooks/useEffectOnce';
import { SignInErrorCodes } from 'pages/SignIn/errorCodes';
import { signInRoutes } from 'pages/SignIn/routes';
import { useHistory } from 'utils/router';

export const PostSSOError = () => {
  const history = useHistory();
  const { search } = useLocation();

  useEffectOnce(() => {
    const params = new URLSearchParams(search);
    const error = params.get('error');

    const errorCode =
      error === 'mfa_requires_password' ? SignInErrorCodes.MFA_REQUIRES_PASSWORD : SignInErrorCodes.INVALID_USER;

    history.push(signInRoutes.base, { errorCode });
  });

  return (
    <Page heading="Redirecting" title="Redirecting">
      <PagePanel id="panel">
        <Loader id="loader" label="This should not take longer than a few seconds." />
      </PagePanel>
    </Page>
  );
};
